import { useLanguage } from "../contexts/LanguageContext";

export const MaintenancePage = ({ message }) => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center px-4" data-testid="maintenance-page">
      <div className="text-center max-w-lg">
        <div className="w-20 h-20 mx-auto mb-8 rounded-full bg-[#C4956A]/20 flex items-center justify-center">
          <svg className="w-10 h-10 text-[#C4956A] animate-spin" style={{animationDuration: '3s'}} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.204-.107-.397.165-.71.505-.78.929l-.15.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </div>

        <h1 className="font-['Heebo'] text-3xl md:text-4xl font-bold text-white mb-4">
          {language === 'he' ? 'האתר בתחזוקה' : 'Under Maintenance'}
        </h1>

        <p className="text-white/60 text-lg mb-6">
          {message || (language === 'he' 
            ? 'אנחנו עובדים על שיפורים לאתר. נחזור בקרוב!'
            : 'We are working on improvements. We\'ll be back soon!')}
        </p>

        <div className="flex items-center justify-center gap-3 text-[#C4956A]">
          <div className="w-2 h-2 rounded-full bg-[#C4956A] animate-pulse" />
          <span className="text-sm font-medium">
            {language === 'he' ? 'עובדים על זה...' : 'Working on it...'}
          </span>
        </div>
      </div>
    </div>
  );
};
